import styled from 'styled-components';

export const SubHeading = styled('p')({
  fontSize: '1.2em',
  fontWeight: 600,
  marginBottom: '2em',
});

